import { render, staticRenderFns } from "./UploadReceipt.vue?vue&type=template&id=de71f8a0&"
import script from "./UploadReceipt.vue?vue&type=script&lang=js&"
export * from "./UploadReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports